// @ts-nocheck
import { css } from 'styled-components';
import { breakpoint, pxToRem } from '@fil-react-mixins/styled';
export const gridContainerPaddingStyles = css `
  ${(props) => {
    const { margins } = props.theme.size.grid;
    return Object.keys(margins).map((key) => {
        const value = parseFloat(margins[key].value);
        return css `
        ${breakpoint(key, css `
            padding-left: ${pxToRem(value)};
            padding-right: ${pxToRem(value)};
          `)}
      `;
    });
}}
`;
export default gridContainerPaddingStyles;
